// Meta tag, canonical, hreflang e dati strutturati per le pagine pubbliche.
const SITE = "https://operativo-ai.com";

const setMeta = (name, value, attr = "name") => {
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
};

const setLink = (rel, href, hreflang) => {
  const selector = hreflang
    ? `link[rel="${rel}"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]`;
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("link");
    tag.rel = rel;
    if (hreflang) tag.setAttribute("hreflang", hreflang);
    document.head.appendChild(tag);
  }
  tag.href = href;
};

// alternates: { it: "/percorso-it", en: "/path-en" } · path: pagina corrente
export const setSeo = ({ title, description, path, faq, lang = "it", alternates }) => {
  document.documentElement.setAttribute("lang", lang);
  document.title = title;
  setMeta("description", description);
  setMeta("og:title", title, "property");
  setMeta("og:description", description, "property");
  setMeta("og:url", `${SITE}${path}`, "property");
  setMeta("og:locale", lang === "it" ? "it_IT" : "en_US", "property");
  setLink("canonical", `${SITE}${path}`);

  document
    .querySelectorAll('link[rel="alternate"][hreflang]')
    .forEach((el) => el.remove());
  const alt = alternates || { [lang]: path };
  Object.entries(alt).forEach(([code, href]) => {
    setLink("alternate", `${SITE}${href}`, code === "it" ? "it-IT" : code);
  });
  setLink("alternate", `${SITE}${alt.it || path}`, "x-default");

  document.getElementById("faq-schema")?.remove();
  if (faq?.length) {
    const ld = document.createElement("script");
    ld.type = "application/ld+json";
    ld.id = "faq-schema";
    ld.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faq.map(({ q, a }) => ({
        "@type": "Question",
        name: q,
        acceptedAnswer: { "@type": "Answer", text: a },
      })),
    });
    document.head.appendChild(ld);
  }
  return () => document.getElementById("faq-schema")?.remove();
};
